import { useStores } from "../../../core/stores/rootStore";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { action } from "mobx";
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import Stack from 'react-bootstrap/Stack';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Skeleton from 'react-loading-skeleton'
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { formatMonthYear, getExpenseStatus, getConfig } from '../../../utils';
import NumberFormatted from './../../../shared/components/numberFormatted';
import Button from 'react-bootstrap/Button';
import ConfirmPopup from './../../modal/modal';

const InternalExpensesSummary = (props) => {

    let navigate = useNavigate();
    const { t } = useTranslation();
    const { internalExpensesSummaryStore, loginStore } = useStores();
    const { checkCurrentMonth, getSummary, criteria, summary, getPreviousMonth, getNextMonth, isLoading, sendToValidate } = internalExpensesSummaryStore;
    const { accountInfo } = loginStore;

    const [modalSettings, setModalSettings] = useState({});
    const [showValidateConfirm, setShowValidateConfirm] = useState(false);

    useEffect(() => {
        checkCurrentMonth(accountInfo).then(() => getSummary());
    }, []);

    function status(status) {
        switch (status) {
            case 0:
                return <div style={{ marginLeft: '20px' }}>
                    <FontAwesomeIcon className="mx-1" size="2x" icon={solid("spinner")} />
                    <b> {t('initial')}</b>
                </div>;
            case 1:
                return <div style={{ marginLeft: '20px' }}>
                    <FontAwesomeIcon className="mx-1" size="2x" icon={solid("spinner")} />
                    <b> {t('pendingForApproval')}</b>
                </div>;
            case 2:
                return <div style={{ marginLeft: '20px' }}>
                    <FontAwesomeIcon className="mx-1" size="2x" icon={regular("circle-check")} />
                    <b> {t('validated')}</b>
                </div>;
            case 3:
                return <div style={{ marginLeft: '20px' }}>
                    <FontAwesomeIcon className="mx-1" size="2x" icon={solid("ban")} />
                    <b> {t('rejected')}</b>
                </div>;
            default:
                return <span></span>;
        }
    }

    return (
        <div>
            <Card>
                <Card.Body>
                    <div>
                        <Row>
                            <Col xs={3}>
                                <Stack className="ms-auto" direction="horizontal">
                                    <b>{t('status')}</b>
                                    {
                                        isLoading ?
                                            <Skeleton width={100} /> :
                                            status(summary?.internalExpensesStatus)
                                    }

                                </Stack>
                            </Col>
                            <Col>
                                {accountInfo.salaryWinbiz && (summary?.internalExpensesStatus == 0 || summary?.internalExpensesStatus == 3) &&

                                    <Button className="float-end mx-2" variant="secondary" onClick={() => {
                                        setModalSettings({
                                            title: t("validate"),
                                            body: `${t('sendToValidate')}?`,
                                            onConfirm: () => { sendToValidate() }
                                        });
                                        setShowValidateConfirm(true);
                                    }}>
                                        {t("sendToValidate")}</Button>
                                }
                            </Col>
                        </Row>
                    </div>
                </Card.Body>
            </Card>

            <Card className="mt-2">
                <Card.Body>
                    <ConfirmPopup show={showValidateConfirm} isDeleting={false} onClose={() => setShowValidateConfirm(false)} title={modalSettings?.title} body={modalSettings?.body} onClick={modalSettings.onConfirm} />

                    <Row>
                        <Col xs={{ span: 6, offset: 3 }}>
                            <div className="btn-group" style={{ width: '100%' }}>
                                <button className="btn btn-primary"
                                    style={{ backgroundColor: 'rgb(255, 226, 229)', borderColor: 'rgb(255, 226, 229)', color: '#7b0606' }}
                                    onClick={() => getPreviousMonth(accountInfo)}>
                                    <FontAwesomeIcon icon={solid("arrow-left")} />
                                </button>
                                <button className="btn btn-primary"
                                    style={{ backgroundColor: 'rgb(255, 226, 229)', borderColor: 'rgb(255, 226, 229)', color: 'black' }}>
                                    {formatMonthYear(new Date(criteria.year, criteria.month, 1))}
                                </button>
                                <button className="btn btn-primary"
                                    style={{ backgroundColor: 'rgb(255, 226, 229)', borderColor: 'rgb(255, 226, 229)', color: '#7b0606' }}
                                    onClick={() => getNextMonth(accountInfo)}>
                                    <FontAwesomeIcon icon={solid("arrow-right")} />
                                </button>
                            </div>
                        </Col>
                    </Row>
                    {
                        summary.expensesWithPackages?.length > 0 &&

                        <Row>
                            <Col xs={3}>
                                {isLoading ? <Skeleton width="300px" /> :
                                    <button className="btn btn-link"
                                        onClick={() => { navigate(`/expenses/with-package/${criteria.year}/${criteria.month}`) }}>
                                        <FontAwesomeIcon icon={solid("magnifying-glass")} /> {t('internalExpensesWithPackages')}
                                    </button>}
                            </Col>
                            <Col xs={6}>
                                <table className="table table-sm">
                                    <thead>
                                        <tr>
                                            <th>{t('category')}</th>
                                            <th className="text-end">{t('quantity')}</th>
                                            <th className="text-end">{t('unitAmount')}</th>
                                            <th className="text-end">{t('total')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            isLoading ?
                                                (
                                                    Array.from(Array(6), (e, i) => {
                                                        return <tr key={i}>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>
                                                        </tr>
                                                    })
                                                )
                                                :
                                                summary.expensesWithPackages.map((expense, index) => (
                                                    <tr key={index}>
                                                        <td>{t(expense.category)}</td>
                                                        <td className="text-end">{expense.category == "telephoneIT" ?
                                                            <NumberFormatted number={expense.quantity} />
                                                            : expense.quantity}
                                                        </td>
                                                        <td className="text-end"><NumberFormatted number={expense.unitAmount} /></td>
                                                        <td className="text-end"><NumberFormatted number={expense.total} /></td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={3}><b>{t('total')}</b></td>
                                            <td className="text-end"><b>{isLoading ? <Skeleton /> : <NumberFormatted number={summary.expensesWithPackagesTotal} />}</b></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </Col>
                        </Row>
                    }

                    {summary.expensesWithActualCosts?.length > 0 && <Row>
                        <Col xs={3}>
                            <table className="table table-sm">
                                <thead>
                                    <tr>
                                        <th style={{ width: '100%', border: 0 }}>&nbsp;</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        isLoading ?
                                            <tr><th><Skeleton width="300px" /></th></tr>
                                            :
                                            summary.expensesWithActualCosts.map((s, index) => (
                                                <tr key={index}>
                                                    <td style={{ border: 0 }}><button style={{ padding: 0 }} className="btn btn-link"
                                                        onClick={() => { navigate(`/expenses/with-costs/${criteria.year}/${criteria.month + 1}/${s.currency.id}`) }}>
                                                        <FontAwesomeIcon icon={solid("magnifying-glass")} /> {t('internalExpensesWithActualCosts')} {s.currency?.shortName}
                                                    </button></td>
                                                </tr>))
                                    }
                                </tbody>
                            </table>

                        </Col>
                        <Col xs={6}>
                            <table className="table table-sm">
                                <thead>
                                    <tr>
                                        <th className="text-end" style={{ width: '20%' }}>{t('totalAmount')}</th>
                                        <th className="text-end" style={{ width: '20%' }}>{t('vatCollected')}</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        isLoading ?
                                            (
                                                Array.from(Array(6), (e, i) => {
                                                    return <tr key={i}>
                                                        <td><Skeleton /></td>
                                                        <td><Skeleton /></td>

                                                    </tr>
                                                })
                                            )
                                            :
                                            summary.expensesWithActualCosts.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td className="text-end">{item.currency?.shortName} <NumberFormatted number={item.totalAmount} /></td>
                                                    <td className="text-end">{item.currency?.shortName} <NumberFormatted number={item.totalVAT} /></td>
                                                </tr>
                                            ))

                                    }
                                </tbody>
                            </table>
                        </Col>
                    </Row>}

                </Card.Body>
            </Card>
        </div>
    );
};

export default observer(InternalExpensesSummary);
